export const SITE = {
  name: "AU Movies",
  legalName: "AU Movies & Production House",
  cin: "U00000KA2024PTC000000",
  gstin: "29AAAAA0000A1Z5",
  tagline: "Pioneering Pan-India Cinema",
  email: "support@au-movies.com",
  phone: "8088588389",
  phoneDisplay: "+91 80885 88389",
  address: {
    line1: "No 1, Samrudhi Nilaya",
    line2: "Jodi Bhavi Road, Opp. Anjanadri Badminton",
    line3: "Nagasandra, Bangalore",
    pincode: "560073",
    state: "Karnataka",
  },
  socials: {
    instagram: "https://instagram.com/",
    youtube: "https://youtube.com/",
    facebook: "https://facebook.com/",
  },
};

export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_a480d43a-bad5-49dd-91b9-c6e5c6018ecc/artifacts/9ht9htu7_AU%20Movies%20Logo.jpeg",
  hero: "https://static.prod-images.emergentagent.com/jobs/a480d43a-bad5-49dd-91b9-c6e5c6018ecc/images/779ebe8cc12eebc3da356bf5b970ca198a5ffbd623ff03a0257edb0a704d989e.png",
  director: "https://customer-assets.emergentagent.com/job_a480d43a-bad5-49dd-91b9-c6e5c6018ecc/artifacts/aiyqeu2g_santhosha%20Image%20.PNG",
  poster: "https://customer-assets.emergentagent.com/job_a480d43a-bad5-49dd-91b9-c6e5c6018ecc/artifacts/yfljzydd_1st%20Poster%20Zero%20to%20one.jpeg",
  gimbal: "https://static.prod-images.emergentagent.com/jobs/a480d43a-bad5-49dd-91b9-c6e5c6018ecc/images/f3ab5f60c72b18dd3f8a2ac24eb86f7c1a2360ff97eceb9877602a19cbc8f6b7.png",
  arri: "https://images.pexels.com/photos/37593308/pexels-photo-37593308.jpeg",
  earthMoon: "https://images.pexels.com/photos/30596303/pexels-photo-30596303.png",
  beach: "https://static.prod-images.emergentagent.com/jobs/a480d43a-bad5-49dd-91b9-c6e5c6018ecc/images/06de94cd4d86f4859a78927698adae49f9199d50f3285a729f0ab71749248a5c.png",
};

export const LANGUAGES_ALL = ["Kannada", "English", "Hindi", "Telugu", "Tamil", "Malayalam"];
export const LANGUAGES_ROSHA = ["Kannada", "Hindi", "Tamil", "Telugu", "Malayalam"];

export const PROJECTS = {
  current: {
    title: "Zero to One",
    subtitle: "It's Inside You",
    status: "First Schedule Completed",
    languages: LANGUAGES_ALL,
    poster: ASSETS.poster,
    synopsis:
      "A bold, introspective journey from nothingness to the spark of self — Nagaveni Santhosha's debut as Producer, Director and Lead Actor. Shot simultaneously in English with native lip-sync and Kannada, opening pan-India and Asia screens.",
  },
  upcoming: [
    {
      title: "Rosha",
      tag: "Upcoming Feature",
      languages: LANGUAGES_ROSHA,
      bg: ASSETS.beach,
      blurb:
        "A coastal saga of love, longing and the storms that shape a life. Multi-language theatrical release across South India and Hindi belt.",
    },
    {
      title: "Sangarsha",
      tag: "Web Series",
      languages: LANGUAGES_ALL,
      bg: ASSETS.earthMoon,
      blurb:
        "A pan-India web series chronicling the relentless climb of an outsider through the labyrinth of dreams, defeat and reinvention.",
    },
  ],
};

export const FILMOGRAPHY = [
  { year: "2012", title: "Film One", role: "Assistant Director", industry: "Bollywood" },
  { year: "2014", title: "Film Two", role: "Assistant Director", industry: "Bollywood" },
  { year: "2016", title: "Film Three", role: "Associate Director", industry: "Bollywood" },
  { year: "2017", title: "Film Four", role: "Associate Director", industry: "Bollywood" },
  { year: "2019", title: "Film Five", role: "Associate Director", industry: "Bollywood" },
  { year: "2021", title: "Film Six", role: "Associate Director", industry: "Bollywood" },
  { year: "2023", title: "Film Seven", role: "Associate Director", industry: "Bollywood" },
];
